import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { PAGES } from "../lib/constants";
import { toast } from "sonner";

function Deny({ to }) {
  useEffect(() => { toast.error("Bu sayfaya erişim yetkiniz yok"); }, []);
  return <Navigate to={to} replace />;
}

export function ProtectedRoute({ children, page }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  const perms = user.permissions || [];
  if (page && !perms.includes(page)) {
    const first = PAGES.find((p) => perms.includes(p.key));
    if (first) return <Deny to={first.path} />;
    return (
      <div data-testid="no-access-screen" className="flex h-screen flex-col items-center justify-center gap-3 bg-background p-6 text-center">
        <div className="text-3xl font-black text-foreground">403 · Yetkisiz Erişim</div>
        <p className="text-sm text-muted-foreground">Hiçbir sayfaya erişim yetkiniz yok. Lütfen yönetici ile görüşün.</p>
      </div>
    );
  }
  return children;
}
